/**
 * Created by yqr on 2018/4/13.
 */
import request from '@/utils/request'
import qs from 'qs';
export default {
  getCode(phone) {
    return request({
      url: '/front/code/'+phone,
      method: 'get',
    })
  },
  checkCode(phone,code) {
    return request({
      url: '/front/code/'+phone+'/'+code,
      method: 'get',
    })
  },
  register(data) {
    return request({
      url: '/front/register',
      method: 'post',
      data: data
    })
  },
  updateUser(data) {
    return request({
      url: '/front/'+data.id,
      method: 'put',
      data: data
    })
  },
  resetPassword(id,data) {
    return request({
      url: '/front/pwd/'+id,
      method: 'put',
      data:data
    })
  },
  forgotPassword(id,data) {
    return request({
      url: '/front/resetPwd/'+id,
      method: 'put',
      data:data
    })
  },
  getUserByPhone(phone) {
    return request({
      url: '/front/getRegisterUserByPhone/'+phone,
      method: 'get',
    })
  },
  getSettingColumn(){
    return request({
      url: '/front/getSettingColumn',
      method: 'get',
    })
  }
}




// WEBPACK FOOTER //
// ./src/api/registerUser.js